import { config } from 'configuration';
import { Card, Col, Row } from 'ui';
import { useUser } from 'features/auth';
import { HelpItem } from './help-item';

const HelpCard = () => {
  const { nodeUserData } = useUser();

  const technicalSupportUrl = `https://bigheart.zendesk.com/hc/en-us/requests/new?tf_anonymous_requester_email=${encodeURIComponent(nodeUserData.email)}&tf_1900007569785=${encodeURIComponent(nodeUserData._id)}`;

  return (
    <Card marginBottom={false}>
      <Row gutter={[0, 'lg']}>
        <Col span={24}>
          <HelpItem
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            description={import.meta.env.VITE_APP_SUPPORT_EMAIL}
            href={`mailto:${import.meta.env.VITE_APP_SUPPORT_EMAIL}`}
            title="General inquiries"
          />
        </Col>

        <Col span={24}>
          <HelpItem
            additionalText="To cancel or change your recurring donation, please email us at: "
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            description={import.meta.env.VITE_APP_SUPPORT_EMAIL}
            href={`mailto:${import.meta.env.VITE_APP_SUPPORT_EMAIL}`}
            title="Cancel Payment"
          />
        </Col>

        <Col span={24}>
          <HelpItem description="Submit a request" href={technicalSupportUrl} title="Technical Support request" />
        </Col>

        {config.screens.helpScreen.map((item) => (
          <Col key={item.title} span={24}>
            <HelpItem href={item.link} key={item.title} {...item} />
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default HelpCard;
